import { Component, signal } from '@angular/core';
import { ButtonModule } from 'primeng/button';
import { DynamicDialogConfig, DynamicDialogModule, DynamicDialogRef } from 'primeng/dynamicdialog';

/**
 * MP-5742: confirm dialog for removing an archived project from the firm's view.
 * Opened with `data: { codeName }`; closes with `true` on Remove, `undefined` on Cancel.
 */
@Component({
  standalone: true,
  imports: [ButtonModule, DynamicDialogModule],
  templateUrl: './remove-project-confirmation.component.html',
})
export class RemoveProjectConfirmationComponent {
  readonly codeName = signal<string>('');

  constructor(private ref: DynamicDialogRef, config: DynamicDialogConfig) {
    this.codeName.set(config.data?.codeName ?? '');
  }

  closeDialog() {
    this.ref.close();
  }

  remove() {
    this.ref.close(true);
  }
}
